export const isExperimentalModeEnabled = () => {
  return process.env.REACT_APP_EXPERIMENTAL_MODE === '1'
}
